export default "__VITE_ASSET__BInnHuG6__"